// extracted by mini-css-extract-plugin
export default {"firstScan":"az-z","firstScanWithMargin":"bz-z","bold":"cz-z","firstScanWarning":"dz-z"};